import { styled } from "@vitality-ds/system";
import ActionsContainerStyles from "./styles/ActionsContainer.styles";
import BaseBatchActionsStyles from "./styles/BaseBatchActions.styles";
import LeftContentContainerStyles from "./styles/LeftContentContainer.styles";
export var BaseBatchActions = styled("div", BaseBatchActionsStyles);
export var ActionsContainer = styled("div", ActionsContainerStyles);
export var LeftContentContainer = styled("div", LeftContentContainerStyles);